module.exports = __webpack_public_path__ + "img/advantage-item-03.884899c8.png";